export const EUROSTAR_COMPANY_CODE = '9F';
export const EUROSTAR_COMPANY_NAME = 'Eurostar';
export const AMTRAK_COMPANY_CODE = '2V';
export const AMTRAK_COMPANY_NAME = 'Amtrak';

export default function FlightRecommendationService(
    flightSegmentService,
    flightGroupService,
) {
    'ngInject';

    Object.assign(this, {
        isRoundTrip,
        isOneWayTrip,
        getFirstFlight,
        getLastFlight,
        getSelectedGroupsInRecommendation,
        doesOutwardDepartEqualInwardArrival,
        doesInwardDepartEqualOutwardArrival,
        getFlightSupplierId,
        getFlights,
        isTrain,
        getOutwardGroup,
        getInwardGroup,
    });

    function getOutwardGroup(recommendation) {
        return recommendation.FlightGroups[0];
    }

    function getInwardGroup(recommendation) {
        return recommendation.FlightGroups[recommendation.FlightGroups.length - 1];
    }

    function getFirstFlight(recommendation, selectedFlights) {
        const segment = recommendation.FlightSegments[0];
        const group = flightSegmentService.getSelectedGroup(selectedFlights, segment);
        return group.Flights[0];
    }

    function doesOutwardDepartEqualInwardArrival(selectedFlights, recommendation) {
        const {outwardSelectedGroup, inwardSelectedGroup} = getOutwardInwardSelectedGroups(selectedFlights, recommendation);

        const outwardFirstFlight = flightGroupService.getFirstFlight(outwardSelectedGroup);
        const inwardLastFlight = flightGroupService.getLastFlight(inwardSelectedGroup);

        return outwardFirstFlight.DepartureAirport === inwardLastFlight.ArrivalAirport;
    }

    function doesInwardDepartEqualOutwardArrival(selectedFlights, recommendation) {
        const {outwardSelectedGroup, inwardSelectedGroup} = getOutwardInwardSelectedGroups(selectedFlights, recommendation);

        const outwardLastFlight = flightGroupService.getLastFlight(outwardSelectedGroup);
        const inwardFirstFlight = flightGroupService.getFirstFlight(inwardSelectedGroup);

        return inwardFirstFlight.DepartureAirport === outwardLastFlight.ArrivalAirport;
    }

    function getLastFlight(recommendation, selectedFlights) {
        const segment = recommendation.FlightSegments[recommendation.FlightSegments.length - 1];
        const group = flightSegmentService.getSelectedGroup(selectedFlights, segment);
        return group.Flights[group.Flights.length - 1];
    }

    function getSelectedGroupsInRecommendation(recommendation, selectedFlights) {
        return recommendation.FlightSegments.map((segment) =>
            flightSegmentService.getSelectedGroup(selectedFlights, segment));
    }

    function isRoundTrip(recommendation) {
        return recommendation.FlightSegments.length === 2;
    }

    function isOneWayTrip(recommendation) {
        return recommendation.FlightSegments.length === 1;
    }

    function isTrain(recommendation) {
        if (!recommendation) {
            return false;
        }
        return airlineEquals(recommendation, EUROSTAR_COMPANY_CODE, EUROSTAR_COMPANY_NAME)
            || airlineEquals(recommendation, AMTRAK_COMPANY_CODE, AMTRAK_COMPANY_NAME);
    }

    function airlineEquals(recommendation, code, name) {
        return recommendation.MarketingCompanyCode === code
            && recommendation.MarketingCompanyName === name
            || recommendation.MarketingAirlineCode === code
            && recommendation.MarketingAirlineName === name
            || recommendation.ValidatingAirlineCode === code
            && recommendation.ValidatingAirlineName === name;
    }

    function getFlightSupplierId(recommendation) {
        if (!recommendation) {
            return null;
        }
        return recommendation.Supplier
            || recommendation.ServiceOption && recommendation.ServiceOption.Id
            || null;
    }

    function getOutwardInwardSelectedGroups(selectedFlights, recommendation) {
        const outwardSegment = flightSegmentService.getOutwardSegment(recommendation);
        const inwardSegment = flightSegmentService.getReturnSegment(recommendation);

        const outwardSelectedGroup = flightSegmentService.getSelectedGroup(selectedFlights, outwardSegment);
        const inwardSelectedGroup = flightSegmentService.getSelectedGroup(selectedFlights, inwardSegment);

        return {outwardSelectedGroup, inwardSelectedGroup};
    }

    function getFlights(recommendation) {
        const groups = recommendation.FlightSegments
            ? recommendation.FlightSegments.reduce((acc, segment) => [...acc, ...segment.FlightGroups], [])
            : recommendation.FlightGroups;
        return groups.reduce((acc, group) => [...acc, ...group.Flights], []);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/flights/flight-recommendation/flight-recommendation-service.js